import PropTypes from "prop-types";
import React from "react";
import i18n from "i18next";

import { Icon } from "../Common/Icon";
import { checkIsInternalUser } from "../../helpers/Authorization/authorizationHelpers";
import { downloadDocument } from "../../actions";
import desktopExternalEn from "../../assets/SOP_Desktop_External_English.pdf";
import desktopExternalFr from "../../assets/SOP_Desktop_External_French.pdf";
import desktopInternalEn from "../../assets/SOP_Desktop_Internal_English.pdf";
import desktopInternalFr from "../../assets/SOP_Desktop_Internal_French.pdf";
import mobileExternalEn from "../../assets/SOP_Mobile_External_English.pdf";
import mobileExternalFr from "../../assets/SOP_Mobile_External_French.pdf";
import mobileInternalEn from "../../assets/SOP_Mobile_Internal_English.pdf";
import mobileInternalFr from "../../assets/SOP_Mobile_Internal_French.pdf";

const UserManualCard = ({ isMobile }) => {
  const handleDownloadUserManual = () => {
    const manuals = {
      desktopExternalEn: { file: desktopExternalEn, name: i18n.t("help.externalUserManualFile") },
      desktopExternalFr: { file: desktopExternalFr, name: i18n.t("help.externalUserManualFile") },
      desktopInternalEn: { file: desktopInternalEn, name: i18n.t("help.userManualFile") },
      desktopInternalFr: { file: desktopInternalFr, name: i18n.t("help.userManualFile") },
      mobileExternalEn: { file: mobileExternalEn, name: i18n.t("help.externalUserManualFile") },
      mobileExternalFr: { file: mobileExternalFr, name: i18n.t("help.externalUserManualFile") },
      mobileInternalEn: { file: mobileInternalEn, name: i18n.t("help.userManualFile") },
      mobileInternalFr: { file: mobileInternalFr, name: i18n.t("help.userManualFile") }
    };
    const language = localStorage.getItem("language") === "fr" ? "Fr" : "En";
    const manual = manuals[`${isMobile ? "mobile" : "desktop"}${checkIsInternalUser() ? "Internal" : "External"}${language}`];
    downloadDocument(manual.file, manual.name);
  };
  return (
    <div className="help__card">
      <Icon className="help__user-manual-card-icon" id="book-bookmark" />
      <div className="help__card-row">
        <span className="help__card-label">{i18n.t("help.userManual")}</span>
        <button className="button" onClick={handleDownloadUserManual}>
          <Icon id="download" className="button__download-icon --middle" />
        </button>
      </div>
    </div>
  );
};

UserManualCard.propTypes = { isMobile: PropTypes.bool };
UserManualCard.defaultProps = { isMobile: false };

export default UserManualCard;



// WEBPACK FOOTER //
// ./src/components/Help/UserManualCard.js